import { Flex } from '@banhala/ui-kit';
import { HTMLText } from 'shared/src/component/HTMLText';
import { useGoodsDetail } from '../../../queries/useGoodsDetail';
import { DeliveryBadgeRow } from './DeliveryBadgeRow';
import { TitleContent } from './TitleContent';

export const ThirdPLDeliverySection = () => {
  const { data: goodsDetail } = useGoodsDetail();

  return (
    <>
      <TitleContent title={'배송정보'}>
        <Flex gap={4}>
          <Flex.Row gap={8} alignItems={'center'}>
            <DeliveryBadgeRow testID={'도착보장툴팁'} />
          </Flex.Row>
        </Flex>
      </TitleContent>
      <Flex margin={{ top: 4 }}>
        <TitleContent title={''}>
          <Flex.Row alignItems={'center'}>
            <HTMLText type="body2">
              {goodsDetail?.goods.send_expectation_info?.formatted_message ??
                ''}
            </HTMLText>
          </Flex.Row>
        </TitleContent>
      </Flex>
    </>
  );
};
